<template>
    <div class="flex center v_center column">
      <h1 style="font-size: 10rem">404</h1>
      <h2 style="margin-top: 15px;">Not Found</h2>
    </div>
</template>

<script>
import MainLayout from "../layouts/MainLayout"
export default {
  data() {
    return {}
  },
  components: {
    MainLayout
  },

}
</script>
